export const embedMessageTypes = {
  CREATIVE_URL: 'CREATIVE_URL',
  CREATIVE_VALIDATIONS: 'CREATIVE_VALIDATIONS',
  EMBED_ERROR: 'EMBED_ERROR',
  EMBED_SESSION_REQUIRED: 'EMBED_SESSION_REQUIRED',
}
